<script setup>
const emit = defineEmits(['close'])

const model = defineModel({ type: Boolean, default: true })

defineProps({
  title: {
    type: String,
    required: false,
  },
  variant: {
    type: String,
    default: 'info',
    validator: value => ['info', 'error', 'warning', 'success'].includes(value),
  },
  dismissible: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: 'info-circle',
  },
})

const dismiss = () => {
  model.value = false
  emit('close')
}
</script>

<template>
  <div
    v-if="model"
    class="flex flex-row rounded-[10px] text-sm"
    :class="{
      [variant]: variant,
    }"
    role="alert"
  >
    <div class="flex grow flex-row items-center gap-2 px-4 py-2">
      <ImoIcon
        :size="24"
        :name="icon"
        :class="{
          'text-info-70': variant === 'info',
          'text-error-70': variant === 'error',
          'text-warning-90': variant === 'warning',
          'text-success-80': variant === 'success',
        }"
      />
      <div class="flex grow flex-col gap-1">
        <h1
          v-if="title"
          class="font-semibold"
          :class="{
            'text-info-70': variant === 'info',
            'text-error-70': variant === 'error',
            'text-warning-90': variant === 'warning',
            'text-success-80': variant === 'success',
          }"
        >
          {{ title }}
        </h1>
        <div
          :class="{
            'text-info-70': variant === 'info',
            'text-error-70': variant === 'error',
            'text-warning-90': variant === 'warning',
            'text-success-80': variant === 'success',
          }"
        >
          <slot />
        </div>
      </div>
      <ImoIcon
        v-if="dismissible"
        :size="24"
        name="close-square"
        @click="dismiss"
        class="cursor-pointer"
      />
    </div>
  </div>
</template>

<style scoped>
@reference "@/assets/style/main.css";

.info {
  @apply bg-info-0 text-info-90;
}

.error {
  @apply bg-error-20 text-error-60;
}

.warning {
  @apply bg-warning-20 text-warning-100;
}

.success {
  @apply bg-success-20 text-success-100;
}
</style>
